import { TabStyles } from '@tableau/widgets';

import { cssClass } from '../../../style';

const cssPrefix = 'InitializationForm';

export namespace InitializationFormStyles {

  export const initializationForm = cssClass(cssPrefix, 'initialization-form', {
    textAlign: 'center',
    position: 'absolute',
    minWidth: '500px',
    top: '15%',
    right: '0',
    bottom: '0',
    left: '0',
  });

  export const initializationLabel = cssClass(cssPrefix, 'initialization-label', {
    marginBottom: TabStyles.Spacing.LargeSpace,
    marginTop: TabStyles.Spacing.SmallSpace,
    fontSize: TabStyles.Typography.Sizing.XLarge,
  });

  export const initializationFormElement = cssClass(cssPrefix,
      'initialization-form-element', {
    display: 'inline-block',
  });

  export const initializationInput = cssClass(cssPrefix, 'initialization-input', {
    display: 'block',
    marginBottom: TabStyles.Spacing.SmallSpace,
    width: '300px',
  });

  export const errorText = cssClass(cssPrefix, 'error-text', {
    color: TabStyles.Colors.AttentionDark,
  });

  export const initializationButton = cssClass(cssPrefix, 'initialization-button', {
    marginTop: TabStyles.Spacing.LargeSpace,
  });
}

